import { FiX } from "react-icons/fi";

import { useContext } from "react";
import { useTranslator } from "@eo-locale/react";

import { Heading, HStack, IconButton } from "@/storybook-components";
import { CropperContext, CropperContextType } from "../context";

function Header() {
  const { translate } = useTranslator();
  const { destroyCrop } = useContext(CropperContext) as CropperContextType;

  return (
    <HStack w="full" justify="space-between">
      <Heading as="h2" size="md" fontWeight={600} color="gray.900" p={0}>
        {translate("common.addImage")}
      </Heading>
      <IconButton
        icon={<FiX />}
        fontSize={24}
        variant="ghost"
        colorScheme="gray"
        onClick={destroyCrop}
        aria-label={translate("common.close")}
      />
    </HStack>
  );
}

export { Header };
